import { Component, Inject, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { IAutorizacoes } from 'src/app/interfaces/token/IAutorizacoes';
import { ENVIRONMENT } from 'src/app/constants';
import { Environment } from 'src/app/types';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  options: AnimationOptions = {
    path: '/assets/animations/dashboard.json'
  };
  autorizacoes: IAutorizacoes;
  constructor(
    private authService: AuthenticationService,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}
  sair() {
    this.authService.logoutUsuario();
  }

  ngOnInit() {
    this.autorizacoes = this.authService.obterToken()['autorizacoes'];
  }
}
